import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_basic_setting = _resolveComponent("basic-setting")
  const _component_time_setting = _resolveComponent("time-setting")
  const _component_motion_setting = _resolveComponent("motion-setting")
  const _component_visitor_setting = _resolveComponent("visitor-setting")
  const _component_communal_fee_setting = _resolveComponent("communal-fee-setting")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_secondary_nav, {
        navs: _ctx.secondMenus,
        active: _ctx.activeNavItem,
        onChoose: _ctx.changePath
      }, null, 8, ["navs", "active", "onChoose"]),
      (_ctx.type==='BasicSetting')
        ? (_openBlock(), _createBlock(_component_basic_setting, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.type==='TimeSetting')
        ? (_openBlock(), _createBlock(_component_time_setting, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.type==='MotionSetting')
        ? (_openBlock(), _createBlock(_component_motion_setting, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.type==='VisitorSetting')
        ? (_openBlock(), _createBlock(_component_visitor_setting, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.type==='CommunalFeeSetting')
        ? (_openBlock(), _createBlock(_component_communal_fee_setting, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ]))
}